import styled from 'styled-components'
import {COLOR} from 'src/service/constant/color'

const PcHeaderWrap = styled.div`
  position: fixed;
  top: 0;
  z-index: 998;
  height: 76px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);

  > div {
    width: 100%;
  }
`

const PcHeaderLeft = styled.section`
  height: 76px;
  line-height: 76px;
  margin-left: 24px;

  > img {
    cursor: pointer;
    display: inline-block;
    height: 31.75px;
    vertical-align: middle;

  }
`

const PcHeaderRight = styled.section`
  display: flex;
  font-family: NanumSquareNeoHeavy, sans-serif;
  font-size: 18px;
  line-height: 76px;

  > a {
    color: ${COLOR.gray70};
    margin: 0 38px 0 0;

    &:hover {
      color: ${COLOR.point1};
    }
  }

  > div {
    display: block;
    margin: 0 38px 0 0;
    color: ${COLOR.gray70};
    cursor: pointer;

    &:hover {
      color: ${COLOR.point1};
    }

    > section {
      display: block;

      > p {
        margin: 0;
        text-align: right;
      }

      > div {
        line-height: 64px;
        height: 64px;
        position: absolute;
        z-index: 1;
        top: 76px;
        display: inline-block;

        .active {
          color: ${COLOR.gray50};
        }

        > a {
          color: ${COLOR.gray40};
          line-height: 64px;
          padding-right: 36px;

          &:hover {
            color: ${COLOR.gray50};
          }
        }
      }
    }
  }

  > section {
    display: flex;

    > img {
      margin: 16px 30px 16px 12px;
      display: flex;
      width: 44px;
      height: 44px;
      cursor: pointer;
    }
  }
`

const PcHeaderUserTab = styled.section<{ display: string }>`
  display: ${(props) => props.display === "true" ? "block" : "none"};
  position: absolute;
  top: 71px;
  right: 31px;
  border-radius: 18px;
  width: 228px;
  height: 200px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
  background: white;
  gap: 24px;
  text-align: center;

  > a, > p {
    cursor: pointer;
    width: 228px;
    display: inline-block;
    line-height: 50px;
    font-size: 18px;
    margin: 0;
    font-family: NanumSquareNeoHeavy, sans-serif;
  }

  > p {
    color: ${COLOR.gray40};
  }
`

const MoHeaderUserTab = styled.section<{ display: string }>`
  display: ${(props) => props.display === "true" ? "block" : "none"};
  position: absolute;
  top: 48px;
  right: 0;
  border-radius: 18px;
  width: 156px;
  height: 164px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
  background: white;
  gap: 24px;
  text-align: center;

  > a, > p {
    cursor: pointer;
    width: 156px;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    margin: 0;
    font-family: NanumSquareNeoHeavy, sans-serif;
  }

  > p {
    color: ${COLOR.gray40};
  }
`
const MoHeaderWrap = styled.div`
  width: 100%;
  height: 48px;
  position: fixed;
  top: 0;
  z-index: 996;
  background: red;
  background: rgba(255, 255, 255, 0.7);
  min-width: 328px;

`
const MoHeaderTab = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  min-width: 328px;


  > section {
    display: flex;
    gap: 15px;

    > img {
      margin: 10.5px 0 10.5px 16px;
      display: flex;
      width: 27px;
      height: 27px;
    }

    > button {
      width: 68px;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: white;
      font-family: NanumSquareNeoHeavy, sans-serif;
      border: none;
      background: ${COLOR.point1};
      border-radius: 30px;
      margin: 10px 0 0 0;
    }

    > img {
      margin: 10px 0 0 0;
      display: flex;
      width: 28px;
      height: 28px;
    }
  }

  > img {
    margin: 10.5px 0 10.5px 16px;
    display: flex;
    width: 27px;
    height: 27px;
  }

`
const MoHeaderIcon = styled.div<{ active: string }>`
  display: block;
  cursor: pointer;
  z-index: 997;
  margin: 10.5px 16px 10.5px 0;

  > div {
    width: 18px;
    height: 2.3px;
    margin: 5px;
    transition: all 0.3s ease;
    background-color: black;
  }

  .burger_line1 {
    transform: ${(props) => props.active === 'true' && 'rotate(-45deg) translate(-4.5px, 6px)'};
  }

  .burger_line2 {
    opacity: ${(props) => props.active === 'true' && '0'};
  }

  .burger_line3 {
    transform: ${(props) => props.active === 'true' && 'rotate(45deg) translate(-4.5px, -6px)'};
  }
`
const MoHeaderContent = styled.div<{ active: string }>`
  position: absolute;
  top: 0;
  left: ${(props) => props.active === 'true' ? '0' : '-100%'};
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  width: 100%;
  height: 1000vh;
`
const MoHeaderContentInner = styled.div<{ active: string }>`
  max-width: 600px;
  width: 100%;
  margin-top: -48px;
  height: 100%;
  display: block;
    // display: ${(props) => props.active === 'true' ? 'block' : 'none'};
  position: fixed;
  right: ${(props) => props.active === 'true' ? '0' : '-100%'};
  transition: right 400ms;
  top: 48px;
  background-color: white;
`
const MoHeaderMenu = styled.div`
  width: 100%;
  display: block;
  padding-top: 61px;
`

const MoHeaderMenuItem = styled.div`
  padding: 24px 32px 24px;
  cursor: pointer;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  font-family: NanumSquareNeoHeavy, sans-serif;
`
const MoHeaderArrow = styled.img<{ transform: string }>`
  display: flex;
  width: 24px;
  height: 12px;
  transform: ${(props) => props.transform === 'false' && 'rotate(180deg)'};
  transition: transform 500ms;
`
const MoHeaderSubMenu = styled.div`
  display: block;

  > span {
    display: inline-block;
    width: 100%;
    font-family: NotoSansMedium, sans-serif;
    padding: 0 0 0 32px;
    font-size: 16px;
    line-height: 23px;
    color: ${COLOR.blueGray5};
    margin-bottom: 24px;
  }
`
export {
    PcHeaderWrap,
    PcHeaderLeft,
    PcHeaderRight,
    MoHeaderWrap,
    MoHeaderIcon,
    MoHeaderContent,
    MoHeaderTab,
    MoHeaderContentInner,
    MoHeaderMenu,
    MoHeaderMenuItem,
    MoHeaderSubMenu,
    MoHeaderArrow,
    PcHeaderUserTab,
    MoHeaderUserTab
}
